import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "debug-info",
  style: {"background-color":"white"}
}
const _hoisted_2 = { class: "text-white" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "h1 text-white" }, "Scholarship Search"),
  /*#__PURE__*/_createElementVNode("p", { class: "lead text-gray-300" }, "In order to find all the scholarships that you are eligible for please provide answers to the following questions:")
], -1)
const _hoisted_4 = { class: "my-5" }
const _hoisted_5 = { class: "progress progress-lg" }
const _hoisted_6 = ["aria-valuenow", "aria-valuemax"]
const _hoisted_7 = { class: "text-gray-300" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-alt-circle-left me-2" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Previous ")
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "col" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Next ")
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-alt-circle-right ms-2" }, null, -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Submit ")
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-alt-circle-right ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_response_page = _resolveComponent("response-page")!
  const _component_activity_button = _resolveComponent("activity-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", null, "CPID: " + _toDisplayString(_ctx.searchPage.state.currentPageId), 1),
          _createElementVNode("div", null, "Responses: " + _toDisplayString(_ctx.searchPage.getters.responses), 1),
          _createElementVNode("span", _hoisted_2, "Assertions: " + _toDisplayString(_ctx.searchPage.state.assertions.value), 1)
        ]))
      : _createCommentVNode("", true),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: "progress-bar bg-success progress-bar-striped progress-bar-animated",
          role: "progressbar",
          style: _normalizeStyle(`width: ${_ctx.searchPage.getters.approximatePercentComplete.value}%`),
          "aria-valuenow": _ctx.searchPage.getters.numberOfQuestionsCompleted.value,
          "aria-valuemin": "0",
          "aria-valuemax": _ctx.searchPage.getters.projectedPathQuestions.value
        }, _toDisplayString(_ctx.searchPage.getters.approximatePercentComplete.value) + "% ", 13, _hoisted_6)
      ]),
      _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.searchPage.getters.numberOfQuestionsCompleted) + " / ~ " + _toDisplayString(_ctx.searchPage.getters.projectedPathQuestions.value) + " Total Questions Completed", 1)
    ]),
    _createElementVNode("section", null, [
      _createVNode(_component_response_page)
    ]),
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            class: _normalizeClass(["btn btn-lg w-100", _ctx.searchPage.getters.priorPageEnabled.value ? 'btn-success' : 'btn-secondary' ]),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.searchPage.actions.decrementPage && _ctx.searchPage.actions.decrementPage(...args))),
            disabled: !_ctx.searchPage.getters.priorPageEnabled.value
          }, _hoisted_13, 10, _hoisted_10)
        ]),
        _createElementVNode("div", _hoisted_14, [
          (_ctx.searchPage.getters.hasMorePages.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-success btn-lg w-100",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.searchPage.actions.incrementPage && _ctx.searchPage.actions.incrementPage(...args)))
              }, _hoisted_17))
            : (_openBlock(), _createBlock(_component_activity_button, {
                key: 1,
                class: "btn btn-success btn-lg w-100",
                clickHandler: _ctx.searchPage.actions.performCompletion
              }, {
                default: _withCtx(() => [
                  _hoisted_18,
                  _hoisted_19
                ]),
                _: 1
              }, 8, ["clickHandler"]))
        ])
      ])
    ])
  ]))
}